import React from "react"

export default function ListWaiting() {
	return (
		<div>
			<h2>ListWaiting</h2>
		</div>
	)
}
